"use client";

import React, { useRef } from "react";
import Hero from "./Sections/Hero";
import PeranUmkm from "./Sections/PeranUmkm";
import PeranKementerian from "./Sections/PeranKementerian";
import Produktivitas from "./Sections/Produktivitas";
import Tantangan from "./Sections/Tantangan";
import IsuStrategis from "./Sections/IsuStrategis";
import ProgramStrategis from "./Sections/ProgramStrategis";
import LangkahStrategis from "./Sections/LangkahStrategis";
import SapaUmkm from "./Sections/SapaUmkm";

const ArahKebijakan = () => {
  const peranUmkmRef = useRef(null);

  const scrollToPeranUmkm = () => {
    peranUmkmRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="relative flex flex-col w-full gap-10 sm:gap-12 md:gap-20">
      <Hero onScrollClick={scrollToPeranUmkm} />
      <div ref={peranUmkmRef}>
        <PeranUmkm />
      </div>
      <PeranKementerian />
      <Produktivitas />
      <Tantangan />
      <IsuStrategis />
      <ProgramStrategis />
      <LangkahStrategis />
      <SapaUmkm />
    </div>
  );
};

export default ArahKebijakan;
